<template>
  <div class="bxp-loading-screen">
    <div class="bxp-loading-content">
      <img
        v-if="!success"
        class="bxp-loading-image"
        src="https://mark-cdn.bountixp.com/marketing-v2/wp-content/uploads/2019/09/bountiXP-setup-logo.gif"
      />
      <img
        v-else
        class="bxp-loading-image"
        src="https://mark-cdn.bountixp.com/marketing-v2/wp-content/uploads/2019/09/bountiXP-setup-success-logo.gif"
      />
      <div v-if="!success">
        <slot name="loading-content"></slot>
      </div>
      <div v-else>
        <slot name="success-content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "success"
    ]
};
</script>

<style>
.bxp_loading-text {
  display: inline-block;
  font-size: 18px;
  margin-bottom: 20px !important;
}

.bxp-loading-screen {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: white;
  width: 100%;
  height: 100vh;
  z-index: 9999999;
}

.bxp-loading-content {
  text-align: center;
  margin-bottom: 48px;
  width: 236px;
}

.bxp-loading-image {
  max-width: 150px !important;
  margin: auto;
  margin-bottom: 32px;
}

.bxp-loading-screen h1 {
  text-align: center;
}
</style>
